// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddAlignmentPopup-module__wrapper___wAqgm {
  padding: 25px 30px;
  display: grid;
  column-gap: 30px;
  row-gap: 25px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.AddAlignmentPopup-module__wrapper___wAqgm .AddAlignmentPopup-module__width100___IcXb4 {
  grid-column: 3 span;
}

.AddAlignmentPopup-module__buttonsContainer___QWcG9 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
  justify-content: end;
  padding: 30px;
  display: flex;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/popups/AddAlignmentPopup/AddAlignmentPopup.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,gDAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,2CAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;AAAF","sourcesContent":[".wrapper {\n  padding: 25px 30px;\n  display: grid;\n  column-gap: 30px;\n  row-gap: 25px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n\n  .width100 {\n    grid-column: 3 span;\n  }\n}\n\n.buttonsContainer {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n  justify-content: end;\n  padding: 30px;\n  display: flex;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `AddAlignmentPopup-module__wrapper___wAqgm`,
	"width100": `AddAlignmentPopup-module__width100___IcXb4`,
	"buttonsContainer": `AddAlignmentPopup-module__buttonsContainer___QWcG9`
};
module.exports = ___CSS_LOADER_EXPORT___;
